import AppFormContainer from '@nxsys/components/AppFormContainer';
import { StyledAppSelect } from '@nxsys/components/AppSelect/index.styled';
import { Form } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import StepCard from './StepCard';
import { regulationOptions } from '@nxsys/constants/AppConstants';

interface AddWorkingTimeRegulationProps {
  stepNumber: number;
  workingTimeRegulation?: string | null;
  completed?: boolean;
  onSubmitStep: (values: any) => void;
}

type AddWorkingTimeRegulationValues = {
  workingTimeRegulationValue: string;
};

const AddWorkingTimeRegulation: React.FC<AddWorkingTimeRegulationProps> = ({
  stepNumber,
  workingTimeRegulation,
  completed = false,
  onSubmitStep,
}) => {
  const [form] = Form.useForm<AddWorkingTimeRegulationValues>();
  const { messages } = useIntl();

  const onFinish = (values: AddWorkingTimeRegulationValues) => {
    const params = {
      workingTimeRegulation: values?.workingTimeRegulationValue ?? null,
    };
    onSubmitStep(params);
  };

  return (
    <StepCard
      title={messages['prospect.onboarding.addWorkingTimeRegulation'] as string}
      stepNumber={stepNumber}
      completed={completed}
      actions={[
        {
          variant: 'outlined',
          name: messages['common.save'] as string,
          onClick: () => form.submit(),
        },
      ]}
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        initialValues={{
          workingTimeRegulationValue: workingTimeRegulation ?? undefined,
        }}
        wrapperCol={{ span: 24 }}
        layout="vertical"
      >
        <Form.Item
          label={messages['prospect.onboarding.workingTimeRegulation'] as string}
          name="workingTimeRegulationValue"
          rules={[
            {
              required: true,
              message: messages['form.pleaseSelect'] as string,
            },
          ]}
        >
          <StyledAppSelect
            options={regulationOptions}
            placeholder={
              messages['prospect.onboarding.workingTimeRegulation.placeholder'] as string
            }
            showSearch
          />
        </Form.Item>
      </AppFormContainer>
    </StepCard>
  );
};

export default AddWorkingTimeRegulation;
